import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import AuthPage from "@/pages/AuthPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import ReportPage from "@/pages/ReportPage";
import ProfilePage from "@/pages/ProfilePage";
import RadioPage from "@/pages/RadioPage";
import ChecklistPage from "@/pages/ChecklistPage";
import VolunteersPage from "@/pages/VolunteersPage";
import SetPasswordPage from "@/pages/SetPasswordPage";
import { Toaster } from "@/components/ui/sonner";
import { Plus } from "lucide-react";

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <img
          src="https://customer-assets-39nsmqrw.emergentagent.net/job_xenodochial-hawking-11/artifacts/bmm38dl4_emblema_CRI.jpg"
          alt="Croce Rossa Italiana"
          className="h-16 w-16 rounded-xl object-cover animate-pulse"
        />
        <p className="text-muted-foreground text-sm">Caricamento…</p>
      </div>
    </div>
  );
}

function Gate() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  return (
    <Routes>
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/auth" element={user ? <Navigate to="/" replace /> : <AuthPage />} />
      <Route path="/admin" element={user ? <AdminPage /> : <Navigate to="/auth" replace />} />
      <Route path="/report" element={user ? <ReportPage /> : <Navigate to="/auth" replace />} />
      <Route path="/profilo" element={user ? <ProfilePage /> : <Navigate to="/auth" replace />} />
      <Route path="/radio" element={user ? <RadioPage /> : <Navigate to="/auth" replace />} />
      <Route path="/volontari" element={user ? <VolunteersPage /> : <Navigate to="/auth" replace />} />
      <Route path="/checklist" element={user ? <ChecklistPage /> : <Navigate to="/auth" replace />} />
      <Route path="/" element={user ? <DashboardPage /> : <Navigate to="/auth" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Gate />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
